// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsApiRequestLogRequestsResult = objectOf({
  hits: number,
  hits_capped: boolean,
  start_time_epoch_seconds: number,
  end_time_epoch_seconds: number,
  results: arrayOf(
    objectOf({
      id: string,
      timestamp_ms: number,
      api_key: string,
      api_key_name: string,
      method: string,
      endpoint: string,
      response_code: number,
      request_body: maybe(string, true),
    })
  ),
});
